export { DisallowedSyntaxError, parse } from "./parse/parser.js";
export type {
  ArrayPattern,
  ArrayExpression,
  ArrowFunctionExpression,
  AssignmentExpression,
  AssignmentPattern,
  AssignmentProperty,
  AwaitExpression,
  BinaryExpression,
  BlockStatement,
  BooleanLiteral,
  BreakStatement,
  CallExpression,
  CatchClause,
  ConditionalExpression,
  ContinueStatement,
  DoWhileStatement,
  EmptyStatement,
  Expression,
  ExpressionStatement,
  ExportDefaultDeclaration,
  ExportNamedDeclaration,
  ImportDeclaration,
  ImportDefaultSpecifier,
  ImportNamespaceSpecifier,
  ImportSpecifier,
  ForInStatement,
  ForOfStatement,
  ForStatement,
  FunctionDeclaration,
  FunctionExpression,
  Identifier,
  IfStatement,
  LogicalExpression,
  MemberExpression,
  MetaProperty,
  NewExpression,
  NullLiteral,
  NumericLiteral,
  ObjectExpression,
  ObjectPattern,
  ParseResult,
  PatternTarget,
  Property,
  RegexLiteral,
  RestElement,
  ReturnStatement,
  SequenceExpression,
  SourceSpan,
  SpreadElement,
  Statement,
  StringLiteral,
  SwitchCase,
  SwitchStatement,
  TaggedTemplateExpression,
  TemplateElement,
  TemplateLiteral,
  ThisExpression,
  ThrowStatement,
  TryStatement,
  UnaryExpression,
  UndefinedLiteral,
  UpdateExpression,
  UpdateTarget,
  VariableDeclaration,
  VariableDeclarationKind,
  VariableDeclarator,
  WhileStatement
} from "./parse/parser.js";
